export default __webpack_public_path__ + "static/media/matrixx-icon.f34f7224.png";